<template>
  <v-dialog
    v-model="isOpen"
    max-width="700"
    @input="handleClose"
  >
    <v-card>
      <v-card-title class="headline mb-4">
        Вы точно хотите удалить эту связь (ребёнка)?
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close()">Закрыть</v-btn>
        <v-btn text color="primary" @click="deleteChild">Удалить</v-btn>
      </v-card-actions>

      <overlay-loader :show="isLoading"></overlay-loader>
    </v-card>
  </v-dialog>
</template>

<script>
import OverlayLoader from '@/app/shared/components/app-loader/Loader.vue';

export default {
  name: 'confirmDeletionModal',
  components: {
    OverlayLoader,
  },
  data() {
    return {};
  },
  computed: {
    isOpen: {
      get() {
        return this.$store.getters.IS_CONFIRM_DELETION_CHILD_MODAL;
      },
      set(value) {
        this.$store.commit('SET_CONFIRM_DELETION_CHILD_MODAL', value);
      }
    },
    isLoading: {
      get() {
        return this.$store.getters.IS_CHILD_DELETION_LOADING;
      },
      set(value) {
        this.$store.commit('SET_CHILD_DELETION_LOADING', value);
      }
    },
    idFirebase() {
      return this.$route.params.idFirebase;
    },
    idChild() {
      return this.$store.getters.ID_CHILD_TO_DELETE;
    }
  },
  methods: {
    handleClose(isOpen) {
      if (!isOpen) {
        this.close();
      }
    },
    close() {
      this.$store.commit('SET_CHILD_DELETION_ID', null);
      this.isLoading = false;
      this.isOpen = false;
    },
    deleteChild() {
      let data = {
        idFirebase: this.idFirebase,
        idChild: this.idChild
      }
      this.$store.dispatch('DELETE_CHILD', data)
        .then(() => {
          this.$toast.success('Связь успешно удалена');
          this.$store.dispatch("GET_CHILDREN", this.idFirebase);
        })
        .catch((error) => {
          this.$toast.error('Неизвестная ошибка');
        }).finally(() => {
        this.close();
      });
    }
  },
};
</script>
